import React, { useEffect, useState } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Modal,
  Button,
  ParagraphText,
  FormField,
  TextInput,
  InputStatusMessage,
} from '@leagueplatform/genesis-core';

import { LoadingIndicator } from '@leagueplatform/web-common-components';

import {
  isValidateCodeLength,
  formatConfirmationCode,
  isEmpty,
} from '../../utils/index';
import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';

export function VerifyCodeModel(props: any) {
  const {
    open,
    heading,
    cancelBtn,
    verifyCodeBtn,
    resendCodeBtn,
    onClose,
    description,
    handleResendCode,
    description2,
    type,
    apiLoading,
    verifyApiLoading,
    verifyCode,
  } = props;
  const [browser, setBrowser] = useState<string>('');

  const [confirmationCode, setConfirmationCode] = useState<string>('');
  const [confirmationCodeError, setConfirmationCodeError] =
    useState<string>('');

  const updateErrorState = (value: string) => {
    if (isEmpty(confirmationCode)) {
      setConfirmationCodeError(
        'Please enter the confirmation code sent to you by email.',
      );
    } else if (isValidateCodeLength(value)) {
      setConfirmationCodeError(
        'Please enter the confirmation code sent to you by email.',
      );
    } else {
      setConfirmationCodeError('');
    }
  };

  const handleVerifyCode = () => {
    updateErrorState(confirmationCode);
    if (confirmationCodeError === '' && confirmationCode.length === 8) {
      verifyCode(confirmationCode);
    }
  };

  const onUpdateField = (event: any) => {
    const { value } = event.target;
    setConfirmationCode(value);
  };

  const onBlurField = (event: any) => {
    updateErrorState(event.target.value);
  };

  const onKeyPressField = (event: any) => {
    updateErrorState(event.target.value);
  };

  function myFunction() {
    if (
      (navigator.userAgent.indexOf('Opera') ||
        navigator.userAgent.indexOf('OPR')) !== -1
    ) {
      setBrowser('Opera');
    } else if (navigator.userAgent.indexOf('Edg') !== -1) {
      setBrowser('Edge');
    } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
      setBrowser('Chrome');
    } else if (navigator.userAgent.indexOf('Safari') !== -1) {
      setBrowser('Safari');
    } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
      setBrowser('Firefox');
    } else if (
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      !!document.DOCUMENT_NODE === true
    ) {
      setBrowser('IE');
    } else {
      setBrowser('unknown');
    }
  }
  useEffect(() => {
    myFunction();
  }, []);

  return (
    <Box>
      <Modal.Root open={open}>
        <Modal.Content
          data-testid="verify-modal"
          showCloseButton={false}
          css={
            {
              borderRadius: 'initial',
              background: '#fff',
              padding: '20px 30px',
              // height: '100vh',
              // '.GDS-modal': {
              //   borderRadius: '$none',
              // },
              '@mobile': {
                padding: 16,
              },
              // '.GDS-c-bVpebC-igUcHly-css': {
              '.GDS-modal': {
                borderRadius: '$none',
                margin: '0px',
                // height: '100vh',
                // eslint-disable-next-line no-nested-ternary
                height: ['Firefox'].includes(browser)
                  ? ['RESEND_CODE'].includes(type)
                    ? '100vh'
                    : '95vh'
                  : '',
                position: ['Firefox'].includes(browser) ? 'absolute' : 'fixed',
                // height: ['Firefox'].includes(browser) ? '100vh' : '',
                // maxHeight: ['Firefox'].includes(browser) ? '720px' : 'initial',
              },
            } as GDSStyleObject
          }
          width={{
            '@initial': 'standard',
            '@laptop': '38%',
            '@mobileLandscape': '50%',
            '@tablet': '50%',
          }}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <StackLayout
            css={{
              textAlign: 'center',
              alignItems: 'center',
              opacity: verifyApiLoading || apiLoading ? 0.1 : 'initial',
            }}
          >
            <Box
              css={
                {
                  margin: '$one',
                  backgroundColor: 'White',
                } as GDSStyleObject
              }
            >
              <img
                style={{ cursor: 'pointer' }}
                src={
                  useStaticAsset(
                    SHARED_LIBRARY_ASSET_KEYS.FAILURE_ICON,
                  ) as string
                }
                alt="right arrow icon"
                width="45px"
              />
              <HeadingText
                data-testid="verify-heading"
                level="3"
                size="sm"
                css={
                  {
                    paddingTop: '$one',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '32px',
                    fontSize: 24,
                    color: '#2C3135',
                  } as GDSStyleObject
                }
              >
                {heading}
              </HeadingText>
              <ParagraphText
                data-testid="verify-description"
                css={
                  {
                    margin: '$two $none $one $none',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '24px',
                    fontSize: 16,
                    color: '#2C3135',
                  } as GDSStyleObject
                }
              >
                {description}
              </ParagraphText>
              {type === 'RESEND_CODE' && (
                <ParagraphText
                  data-testid="verify-description2"
                  css={
                    {
                      margin: '$none',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                      fontSize: 16,
                      color: '#2C3135',
                    } as GDSStyleObject
                  }
                >
                  {description2}
                </ParagraphText>
              )}
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                  } as GDSStyleObject
                }
              >
                <FormField
                  data-testid="code-input"
                  id="VerifyCode"
                  label="Confirmation Code"
                  css={
                    {
                      margin: '20px 0px',
                    } as GDSStyleObject
                  }
                  inputStatus={confirmationCodeError ? 'error' : undefined}
                  statusIconLabel={confirmationCodeError ? 'Error' : ''}
                  statusMessage={
                    <InputStatusMessage hideIcon>
                      {confirmationCodeError}
                    </InputStatusMessage>
                  }
                >
                  <TextInput
                    data-testid="codeUpdate"
                    name="confirmationCode"
                    id="confirmationCode"
                    placeholder="Confirmation Code"
                    onChange={onUpdateField}
                    value={formatConfirmationCode(confirmationCode)}
                    maxLength={8}
                    onBlur={onBlurField}
                    onKeyUp={onKeyPressField}
                  />
                </FormField>
              </Box>

              <StackLayout
                horizontalAlignment="start"
                css={{
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Button
                  data-testid="verifycode-btn"
                  size="small"
                  css={
                    {
                      color: '#0074C9',
                      cursor: 'pointer',
                      fontWeight: '700',
                      fontSize: 16,
                      padding: '$one',
                      background: 'none',
                      '&:hover,&:active,&:focus': {
                        background: 'none',
                      },
                    } as GDSStyleObject
                  }
                  onClick={handleVerifyCode}
                >
                  {verifyCodeBtn}
                </Button>

                <Button
                  data-testid="resend-btn"
                  size="small"
                  css={
                    {
                      color: '#0074C9',
                      cursor: 'pointer',
                      fontWeight: '700',
                      fontSize: 16,
                      padding: '$one',
                      background: 'none',
                      '&:hover,&:active,&:focus': {
                        background: 'none',
                      },
                    } as GDSStyleObject
                  }
                  onClick={handleResendCode}
                >
                  {resendCodeBtn}
                </Button>

                <Button
                  data-testid="cancel-btn"
                  size="small"
                  css={
                    {
                      color: '#0074C9',
                      cursor: 'pointer',
                      fontWeight: '700',
                      fontSize: 16,
                      padding: '$one',
                      background: 'none',
                      '&:hover,&:active,&:focus': {
                        background: 'none',
                      },
                    } as GDSStyleObject
                  }
                  onClick={onClose}
                >
                  {cancelBtn}
                </Button>
              </StackLayout>
            </Box>
          </StackLayout>
          {(verifyApiLoading || apiLoading) && <LoadingIndicator />}
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
